module.exports = __webpack_public_path__ + "static/media/scrum6.c376b385.png";